<template>
  <div class="kudos__modal">
    <div class="kudos__overlay" @click="$emit('close')"></div>
    <div class="kudos__modal__content mdl-card mdl-card--auto mdl-card--wide mdl-shadow--2dp">
      <div class="kudos__modal__content__close"></div>
      <template v-if="submitted && !busy">
        <div class="mdl-card__title">
          <h2 class="mdl-card__title-text">Thanks for giving Kudos!</h2>
        </div>
        <div class="p--4">
          <button
            @click="viewFeed"
            :class="`btn ${theme}-bg mr--2`"
          >
            View the feed
          </button>
          <button
            @click="reset"
            :class="`btn ${theme}-bg`"
          >
            Give more
          </button>
        </div>
      </template>
      <template v-else-if="!submitted && !busy">
          <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">Give someone Kudos</h2>
          </div>
          <div class="p--4">
            <p>Let a colleague know that they have done a great job!</p>
            <form @submit.prevent="submit">
              <div>
                <label :class="{ 'text--error' : error}">Who are you giving Kudos to?</label>
                <v-select
                  v-model="receiver"
                  :options="colleagues"
                  @search="handleInput"
                  label="fullName"
                  maxHeight="100"
                  required
                  :key="1"
                />
              </div>
              <div class="mt--4">
                <label :class="{ 'text--error' : error}">What type of Kudos?</label>
                <v-select
                  v-if="kudosTypes && kudosTypes.length"
                  v-model="type"
                  :options="kudosTypes"
                  label="title"
                  required
                  :key="2"
                />
              </div>
              <div class="mt--4">
                <div class="mdl-textfield mdl-js-textfield full-width">
                  <label :class="{ 'text--error' : error}">Your Message:</label>
                  <textarea
                    class="mdl-textfield__input"
                    type="text"
                    rows= "3"
                    id="message"
                    v-model="message"
                  >
                  </textarea>
                </div>
              </div>
              <div class="align--right">
                <button
                  :class="`btn ${theme}-bg w--100`"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
      </template>

      <template v-else-if="!submitted && busy">
        <loading :loading="busy" />
      </template>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Loading from './Loading'
import axios from 'axios'

export default {
  name: 'kudos-modal',
  components: {
    vSelect,
    Loading
  },
  props: {
    clientId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  data: () => ({
    submitted: false,
    busy: true,
    receiver: '',
    type: '',
    message: '',
    colleagues: [],
    test: [],
    kudosTypes: [],
    error: false
  }),
  methods: {
    handleInput (search, loading) {
      if (search.length < 3) {
        this.colleagues = []
        return
      }
      
      this.searchEmployees(search).then(response => {
        this.colleagues = response.data
          .filter(emp => emp.id !== this.userId)
          .map(item => {
            let temp = item
            temp.fullName = `${temp.forename} ${temp.surname}`
            return temp
          })  
      })
    },
    searchEmployees (searchTerm) {
      return axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/employee`, {
        params: {
          clientId: this.clientId,
          searchTerm: searchTerm
        }
      })
    },
    setTypes () {
      return axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-types`, {
        params: {
          clientId: this.clientId
        }
      })
    },
    submit () {
      this.busy = true

      if (!this.receiver.id || !this.type.id || !this.message) {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, 2000)
        this.busy = false
        return
      }

      axios.post(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos`, {
        user_id: this.userId,
        receiver_id: this.receiver.id,
        type_id: this.type.id,
        message: this.message,
        client_id: this.clientId
      }).then(response => {
        this.busy = false
        this.submitted = true
      })
    },
    reset () {
      this.receiver = ''
      this.type = ''
      this.message = ''
      this.busy = false
      this.submitted = false
    },
    viewFeed () {
      if (this.$route.fullPath === '/kudos') {
        this.$emit('close')
        location.reload()
        return
      }

      this.$router.push('/kudos')
      this.$emit('close')
    }
  },
  mounted () {
    this.setTypes().then(response => {
      this.kudosTypes = response.data
      this.busy = false

    })
  }
}
</script>

<style lang="scss" scoped>

  @import '../scss/kudos';

  textarea {
    border: solid 1px #cdcdcd;
    border-radius: 4px;
  }

  .v-select {
    ul {
      max-height: 100px;
    }
  }
</style>
